import * as React from 'react';
import { Button } from '@grandvisionhq/common';
import { Form, Text, Util, Email, PostalCode, ConnectedDatePicker, ConnectedFormSelect, TextArea } from '@grandvisionhq/forms';
import { Alert } from '@grandvisionhq/iris-ui';
import { initialForm } from '../../constants/initial-form.js';

const CancelSubscriptionForm = ({ formRef , isSuccess , isUpdating , labels , onBlur , onChange , onSubmit , selectedCancellationType  })=>{
    return /*#__PURE__*/ React.createElement(React.Fragment, null, isSuccess ? /*#__PURE__*/ React.createElement(Alert, {
        variant: "success",
        title: labels.success.title,
        titleHeadingLevel: "h2"
    }, labels.success.description) : null, /*#__PURE__*/ React.createElement(Form, {
        className: "cancel-subscription-form",
        name: "cancel-subscription-form",
        initialFormState: initialForm,
        onBlur: onBlur,
        onChange: onChange,
        onSubmit: onSubmit,
        ref: formRef
    }, /*#__PURE__*/ React.createElement(Text, {
        id: "subscriptionNumber",
        label: labels.subscriptionNumber.label,
        placeholder: labels.subscriptionNumber.placeholder,
        errorMessage: labels.subscriptionNumber.errorMessage,
        validations: [
            Util.validations.isAlphanumeric
        ],
        required: true,
        "data-t": "subscription-number"
    }), /*#__PURE__*/ React.createElement(Email, {
        id: "email",
        label: labels.email.label,
        placeholder: labels.email.placeholder,
        errorMessage: labels.email.errorMessage,
        required: true
    }), /*#__PURE__*/ React.createElement(PostalCode, {
        label: labels.postalCode.label,
        placeholder: labels.postalCode.placeholder,
        errorMessage: labels.postalCode.errorMessage,
        required: true
    }), /*#__PURE__*/ React.createElement(ConnectedDatePicker, {
        name: "cancellationDate",
        className: "cancel-subscription-form__date-picker",
        label: labels.cancellationDate.label,
        placeholder: labels.cancellationDate.placeholder,
        errorMessage: labels.cancellationDate.errorMessage,
        minDate: new Date(),
        dateFormat: "dd MMMM yyyy",
        required: true,
        autoComplete: false
    }), /*#__PURE__*/ React.createElement(ConnectedFormSelect, {
        id: "cancellationType",
        name: "cancellationType",
        label: labels.cancellationType.label,
        placeholder: labels.cancellationType.placeholder,
        errorMessage: labels.cancellationType.errorMessage,
        required: true,
        options: {
            [labels.cancellationType.options.ordinary]: {
                label: labels.cancellationType.options.ordinary,
                value: 'ORDINARY'
            },
            [labels.cancellationType.options.extraordinary]: {
                label: labels.cancellationType.options.extraordinary,
                value: 'EXTRAORDINARY'
            }
        }
    }), selectedCancellationType === 'ORDINARY' ? /*#__PURE__*/ React.createElement(ConnectedFormSelect, {
        id: "reasonOrdinary",
        name: "reasonOrdinary",
        label: labels.reason.label,
        placeholder: labels.reason.placeholder,
        errorMessage: labels.reason.errorMessage,
        required: true,
        options: {
            [labels.reason.options.changedPrescription]: {
                label: labels.reason.options.changedPrescription,
                value: 'CHANGED_PRESCRIPTION'
            },
            [labels.reason.options.notNeeded]: {
                label: labels.reason.options.notNeeded,
                value: 'NOT_NEEDED'
            },
            [labels.reason.options.tooExpensive]: {
                label: labels.reason.options.tooExpensive,
                value: 'TOO_EXPENSIVE'
            },
            [labels.reason.options.foundAnotherProduct]: {
                label: labels.reason.options.foundAnotherProduct,
                value: 'FOUND_ANOTHER_PRODUCT'
            },
            [labels.reason.options.deliveryProblems]: {
                label: labels.reason.options.deliveryProblems,
                value: 'DELIVERY_PROBLEMS'
            },
            [labels.reason.options.subscriptionManagementProblems]: {
                label: labels.reason.options.subscriptionManagementProblems,
                value: 'SUBSCRIPTION_MANAGEMENT_PROBLEMS'
            },
            [labels.reason.options.other]: {
                label: labels.reason.options.other,
                value: 'OTHER'
            }
        }
    }) : null, selectedCancellationType === 'EXTRAORDINARY' ? /*#__PURE__*/ React.createElement(TextArea, {
        id: "reasonExtraordinary",
        name: "reasonExtraordinary",
        label: labels.reason.label,
        placeholder: labels.reason.placeholder,
        errorMessage: labels.reason.errorMessage,
        maxLength: 200,
        required: true
    }) : null, /*#__PURE__*/ React.createElement(Button, {
        caption: labels.submit,
        className: "cancel-subscription-form__submit",
        isLoading: isUpdating,
        type: "submit",
        disabled: isUpdating
    })));
};

export { CancelSubscriptionForm };
//# sourceMappingURL=CancelSubscriptionForm.js.map
